import posModalTemplate from '../views/pos-modal.tpl.html';
import _ from 'lodash';

class PosService {
    constructor($injector) {
        this.injector = $injector;
        this.modal = this.injector.get('$uibModal');
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
    }

    async openPosModal(contactId, rsvpId, rsvpPax) {
        let predefinedFillData = null
        let invoiceIdentifier = null;
        if (rsvpId) {
            predefinedFillData = await this.loadOpenData('rsvp', rsvpId)
        } else if (contactId) {
            predefinedFillData = await this.loadOpenData('contact', contactId)
        }

        const predefinedDataPromise = async () => {
            if (!predefinedFillData) {
                return null;
            }

            invoiceIdentifier = predefinedFillData.identifier

            return {
                contact_id: contactId,
                invoice_template_id: -1,
                invoice_date: new Date(),
                positions: predefinedFillData.positions
                    .map((originalPos) => {
                        return {
                            "position_link_id": originalPos.id,
                            "position_id": originalPos.position_id,
                            "label": originalPos.label,
                            "description": originalPos.description,
                            "price_per_unit": originalPos.price_per_unit,
                            "child_positions": originalPos.child_positions,
                            "amount": originalPos.amount,
                            "unit": originalPos.unit,
                            "order": originalPos.order,
                            "tax_rate": originalPos.tax_rate,
                            "billable_id": originalPos.billable_id,
                            "billable_type": originalPos.billable_type
                        }
                    }),
                processing_fee: 0,
                address: predefinedFillData ? predefinedFillData.invoice_address : '',
                payment_type: 'cash',
                pax_count: !(typeof rsvpPax === 'undefined') ? rsvpPax : 0
            };
        }

        return this.modal.open({
            controller: 'PosModalController',
            controllerAs: 'vm',
            size: 'xlg',
            templateUrl: posModalTemplate,
            resolve: {
                predefinedData: predefinedDataPromise,
                rsvpId: () => {
                    return rsvpId
                },
                invoiceIdentifier: () => {
                    return invoiceIdentifier
                }
            }
        }).result.catch((e) => {
            console.log(e);
        });
    }

    loadOpenData(entityType, entityId) {
        return this.api.get('billing/invoices/' + entityType + '/' + entityId + '/positions/invoice')
            .then((response) => {
                let positionGroups = _.cloneDeep(response.data.data);
                let extendedData = {};

                _.each(positionGroups, (group, groupKey) => {
                    positionGroups[groupKey].address_type = 'default';

                    let currentOrder = 1;
                    _.each(group.positions, (position, positionKey) => {
                        positionGroups[groupKey].positions[positionKey].enabled = true;
                        positionGroups[groupKey].positions[positionKey].order = currentOrder++;
                    });

                    extendedData[group.identifier] = {
                        invoice_date: new Date(),
                        shipping: false
                    }
                });

                if(positionGroups.length > 0) {
                    return positionGroups[0];
                }
                return null;
            }, () => {
                this.alert.info('No Positions', 'Currently there are no open positions available');
            });
    }
}

PosService.$inject = [
    '$uibModal'
];

/**
 * @ngdoc service
 * @name modules.pos.factory:PosService
 *
 * @description
 *
 */
angular.module('festzelt-os.modules.pos')
    .factory('PosService', [
        '$injector',
        ($injector) => new PosService($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/pos/services/pos-service.js